import { styled, Box } from '@mui/material';
import { neutral } from '_lex/_foundations/phxColors';

export const ContentPage = styled(Box)({
  margin: '0 auto',
  background: '#FFF',
  padding: 36,
  border: `solid 1px ${neutral[200]}`,
  width: '100%',
  maxWidth: 900,
  boxSizing: 'border-box',
  fontSize: 16,
  overflowX: 'hidden',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  // Media queries for viewport-based responsiveness
  '@media (max-width: 900px)': {
    padding: '24px',
  },
  '@media (max-width: 600px)': {
    padding: '16px',
  },
  // Container queries for container-based responsiveness (when parent has container-type)
  '@container (max-width: 900px)': {
    padding: '24px',
  },
  '@container (max-width: 600px)': {
    padding: '16px',
  },
  '& .MuiTypography-h5': {
    fontSize: 27,
  },
  '& .MuiTypography-h6': {
    fontSize: 18,
  },
  // Ensure content inside respects container width
  '& > *': {
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  // Handle tables - make them scrollable within container
  '& .PhxEditorTheme__table': {
    maxWidth: '100% !important',
    width: '100% !important',
    tableLayout: 'auto',
    '&::-webkit-scrollbar': {
      height: '8px',
    },
  },
  // Handle images
  '& img': {
    maxWidth: '100%',
    height: 'auto',
  },
  // Handle code blocks
  '& .PhxEditorTheme__code': {
    maxWidth: '100%',
    overflowX: 'auto',
  },
  // Handle editor content
  '& .editor-container': {
    maxWidth: '100%',
    overflowX: 'hidden',
  },
  '& .editor-scroller': {
    maxWidth: '100%',
    overflowX: 'hidden',
  },
  '& .editor': {
    maxWidth: '100%',
  },
  '.text-entity': {
    padding: '2px 4px',
    borderRadius: 8,
    display: 'inline-flex',
    '&:before': {
      content: '"["',
    },
    '&:after': {
      content: '"]"',
    },
  },
});
